/**
 * Custom Product Slider - Maneja el slider de producto con metaobjetos
 * y actualiza la imagen principal según el slide activo
 */

class CustomProductSlider {
  constructor(sectionId, imagenOriginal, indexInicial) {
    this.sectionId = sectionId;
    this.imagenOriginal = imagenOriginal;
    this.indexInicial = indexInicial;
    
    this.section = document.getElementById(`slider-producto-${sectionId}`);
    if (!this.section) return;

    this.slider = document.getElementById(`product-slider-${sectionId}`);
    this.imagenPrincipal = document.getElementById(`imagen-principal-slider-${sectionId}`);
    this.slides = this.section.querySelectorAll(".hdt-slider__slide");

    this.init();
  }

  init() {
    if (!this.slider) return;

    // Escuchar el evento cuando cambia el slide
    this.slider.addEventListener('select:slide', (event) => {
      const sliderApi = event.detail.sliderApi;
      const selectedIndex = sliderApi.selectedScrollSnap();
      
      console.log("EVENTO select:slide disparado, índice:", selectedIndex);
      this.actualizarImagen(selectedIndex);
    });

    // Escuchar el evento de inicialización
    this.slider.addEventListener('init:slide', (event) => {
      const sliderApi = event.detail.sliderApi;
      const selectedIndex = sliderApi.selectedScrollSnap();
      
      console.log("SLIDER INICIALIZADO, índice inicial:", selectedIndex);
      this.actualizarImagen(selectedIndex);
    });

    // Click en los slides para navegar
    this.slides.forEach((slide, i) => {
      slide.addEventListener("click", () => {
        if (this.slider.goToIndex) {
          this.slider.goToIndex(i);
        }
      });
    });

    // Pequeño delay para asegurar que el slider esté listo
    setTimeout(() => {
      this.actualizarImagen(this.indexInicial);
    }, 100);
  }

  actualizarImagen(index) {
    const slide = this.slides[index];
    if (!slide) return;

    const nuevaImagen = slide.dataset.imagen;
    const reemplazar = slide.dataset.reemplazar === "true";

    console.log("SLIDE ACTIVO:", index);
    console.log("Imagen:", nuevaImagen);
    console.log("Reemplazar:", reemplazar);

    if (nuevaImagen && reemplazar) {
      this.fadeImage(nuevaImagen);
    } else {
      this.fadeImage(this.imagenOriginal);
    }
  }

  fadeImage(src) {
    if (!this.imagenPrincipal) return;
    
    this.imagenPrincipal.style.opacity = 0;
    setTimeout(() => {
      this.imagenPrincipal.src = src;
      this.imagenPrincipal.style.opacity = 1;
    }, 150);
  }
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeSliders);
} else {
  initializeSliders();
}

function initializeSliders() {
  // Los sliders se inicializan desde la sección con window.initCustomProductSlider
}

// Exponer la función de inicialización globalmente
window.initCustomProductSlider = function(sectionId, imagenOriginal, indexInicial) {
  new CustomProductSlider(sectionId, imagenOriginal, indexInicial);
};
